<template>
  <div class="download universal">
    <h1 class="page-title">已下载资源 · {{date_content.totalCount||0}}</h1>

    <None v-if="date_content.list==null||date_content.list.length==0" />
    <div v-else>
      <DownloadResourseItem
        v-for="(item,index) in date_content.list"
        :key="item.id"
        :dateObject="item"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>
    <DevPagination
      class="margin-top-66"
      :total="date_content.totalCount"
      :pageSize="10"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import DownloadResourseItem from "@/components/Resourse/DownloadResourseItem.vue";
import None from "@/components/Base/None.vue";
import { getDownloadList } from "@/utils/api";

export default {
  components: {
    DevPagination,
    DownloadResourseItem,
    None,
  },
  data() {
    return {
      date_content: {},
      pageInfo: "",
    };
  },
  methods: {
    postDate(page) {
      this.pageInfo = page;
      this.date_content.list = [];
      this.$store.dispatch("changeLoading", true);
      getDownloadList({
        pageNum: page.current,
        pageSize: page.pageSize,
      }).then((response) => {
        this.date_content = response.data.data;
        this.$store.dispatch("changeLoading", false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.download {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
